import { adminLogin } from "../../../helpers/apis";
import { loginSuccess, logoutUserSuccess, apiError, enableLoading } from "./reducer";
import { setAuthorization } from "../../../helpers/api_helper";
import { jwtDecode } from "jwt-decode";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    dispatch(enableLoading());

    // Call admin login API
    // Backend response structure: { statusCode, status, message, data: { accessToken, admin } }
    const response = await adminLogin({
      email: user.email,
      password: user.password,
    });

    console.log("Admin Login Response:", response);

    // Check if we have valid response with status 1
    if (response && response.status === 1 && response.data) {
      const { accessToken, admin } = response.data;

      if (!accessToken) {
        dispatch(apiError("Login failed: No access token received"));
        return;
      }

      if (!admin) {
        dispatch(apiError("Login failed: No admin data received"));
        return;
      }

      // Decode JWT to get expiry time
      let decodedToken;
      try {
        decodedToken = jwtDecode(accessToken);
      } catch (decodeError) {
        console.error("Token decode error:", decodeError);
        decodedToken = { exp: Date.now() / 1000 + 86400 * 7 }; // Default 7 days
      }

      // Store token and admin data in localStorage
      const authData = {
        token: accessToken,
        user: admin
      };

      localStorage.setItem("authUser", JSON.stringify(authData));
      localStorage.setItem("expiryAt", decodedToken.exp * 1000);
      localStorage.setItem("expiryIn", decodedToken.exp * 1000 - Date.now());

      console.log("Admin token stored in localStorage:", {
        hasToken: !!accessToken,
        hasAdmin: !!admin,
        adminEmail: admin?.email
      });

      // Set Axios Authorization header
      setAuthorization();

      // Dispatch auth token event for socket reconnection
      try {
        window.dispatchEvent(new CustomEvent("auth:token", { detail: { token: accessToken } }));
      } catch (eventError) {
        console.warn("Unable to broadcast auth token event:", eventError);
      }

      // Dispatch success
      dispatch(loginSuccess({ token: accessToken, user: admin }));

      // Redirect to dashboard
      history("/dashboard");
    } else {
      // Handle error response
      const errorMessage = response?.message || "Login failed. Invalid credentials.";
      dispatch(apiError(errorMessage));
    }
  } catch (error) {
    console.error("Admin Login Error:", error);
    dispatch(apiError(error.message || "Login failed. Please try again."));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("expiryAt");
    localStorage.removeItem("expiryIn");

    try {
      window.dispatchEvent(new CustomEvent("auth:token", { detail: { token: null } }));
    } catch (eventError) {
      console.warn("Unable to broadcast logout token event:", eventError);
    }

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    console.error("Logout Error:", error);
    dispatch(apiError(error.message || "An error occurred during logout."));
  }
};
